import { CircularProgress } from "@mui/material";
import { ErrorMessage, Field, Form, Formik, useFormik, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import TextError from "../../../Components/HealthInsFormikComponent/TextError";
import * as Yup from "yup";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import axiosInstance from "../../../Utilities/djangoAxiosInstance";

const DocForm = () => {
  const { referencetId } = useParams();
  const [pageReady, setPageReady] = useState(false)
  const [proposalNum, setProposalNum] = useState('')

  const navigate = useNavigate()

  //const formFormik = useFormikContext()

  const initialValues = {
    idProof: "",
    adProof: "",
    idProofDoc: "",
    adProofDoc: "",
  };

  // const location = useLocation();
  // console.log('loc', location)
  // It takes a file and returns a promise that resolves to the base64 representation of the file
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        //resolve(fileReader.result);
        const base64 = fileReader.result.split(",")[1];
        resolve(base64);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  // It takes a file, converts it to base64, and then sets the value of the field to the base64 string.
  const handleFileUpload = async (e, setFieldValue, field) => {
    const file = e.target.files[0];
    //console.log(field,formFormik)
    if (file?.size / 1024 / 1024 < 6) {
      const base64 = await convertToBase64(file);
      setFieldValue(field, base64);
      setFieldValue(`${field}Name`, file.name);
    }
    else {
      //setFieldValue(field,'')
      //alert('File size must be of 5MB or less');
      Swal.fire({
        icon: 'error',
        title: 'eee',
        text: 'File size must be of 5MB or less',
        position: 'center',
      }).then(
        result => {
          setFieldValue(field, '')
          e.target.value = '';

        }
      )

    }
  };

  const onSubmit = async (data, { setSubmitting }) => {
    // console.log('sub', data, location.state)
    // let propNo = location.state !== null ? location.state.proposalNumber : ""
    let poiReq = {
      "doc_code":data.idProof,
      uploadEkycDocumentIO: {

        proposalNumber: proposalNum,

        documentName: data.idProofDocName,

        isBase64: "Y",

        documentData: data.idProofDoc,

        docType: "Identity Proof",

      },

    };

    let poaReq = {
      "doc_code":data.adProof,
      uploadEkycDocumentIO: {

        proposalNumber: proposalNum,

        documentName: data.adProofDocName,

        isBase64: "Y",

        documentData: data.adProofDoc,

        docType: "Address Proof",

      },

    };



    let finalReq = {
      
      POA: poaReq,

      POI: poiReq,

    };



    console.log("final request", (finalReq));
    let domain = ''

    if (window.location.hostname === 'localhost') {
      domain = process.env.REACT_APP_LOCAL_DJANGO
    } else if (window.location.hostname.trim() === 'it.acuvisor.com') {
      domain = process.env.REACT_APP_PRODUCTION_DJANGO
    } else {
      domain = process.env.REACT_APP_UAT_DJANGO
    }
    axiosInstance.post(`api/health-insurance/care/kyc/document-upload/${proposalNum.A_id}`, JSON.stringify(finalReq)).then(
      res => {
        console.log('rrr', res)
        if(res.data.message === "Your documents are uploaded"){
          navigate(`/health-insurance/product-stastus/${referencetId}`);

        }
      }
    ) 

    setSubmitting(false); // to stop progress bar
  };



  const validationSchema = Yup.object().shape({
    idProof: Yup.string()
      .required("Select Identity Proof Type")
      .oneOf(["C02", "C03", "C04", "C05"], "Invalid option selected"),

    idProofDoc: Yup.mixed().when("idProof", {
      is: (value) => ["C02", "C03", "C04", "C05"].includes(value),

      then: Yup.mixed().required("Upload Id Proof File"),
    })
    // .test('idProofDoc', '', function(value) {
    //     if (value && this.parent.idProof) {
    //         console.log("test",value)
    //         return true;
    //       }
    //       return false;
    //   }),
    ,
    adProof: Yup.string()
      .required("Select Address Proof Type")
      .oneOf(["C03", "C04", "C05"], "Invalid option selected"),

    adProofDoc: Yup.mixed().when("adProof", {
      is: (value) => ["C02", "C03", "C04", "C05"].includes(value),
      then: Yup.mixed().required("Upload Address Proof File"),
    }),
  });


  useEffect(() => {
    let domain = ''

    if (window.location.hostname === 'localhost') {
      domain = process.env.REACT_APP_LOCAL_DJANGO
    } else if (window.location.hostname.trim() === 'it.acuvisor.com') {
      domain = process.env.REACT_APP_PRODUCTION_DJANGO
    } else {
      domain = process.env.REACT_APP_UAT_DJANGO
    }

    axiosInstance.get(`api/health/createquote-response/${referencetId}/`).then(
      response => {
        console.log('respon', response)
        setProposalNum(response.data.response.proposalNum)
        //setResponseData(response.data.response)
      }
    )


  }, [])




  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(formik) => (
        <Form>
          {console.log('form', formik)}
          <div className="form-container ">
            <div className="d-flex justify-content-center">
              <h3>Document Upload</h3>
            </div>
            <div className="form-group mb-4 ">
              <label htmlFor="idProof fw-bold">Identity Proof</label>
              <Field
                as="select"
                name="idProof"
                id="idProof"
                className={
                  formik.touched.idProof && formik.errors.idProof
                    ? "errorStyle form-control bg-white"
                    : !formik.errors.idProof && formik.touched.idProof
                      ? "successField form-control bg-white"
                      : "form-control bg-white"
                }
              >
                <option>Select Options</option>
                <option value="C02">PAN</option>
                <option value="C03">Voter Id</option>
                <option value="C04">Driving Licence</option>
                <option value="C05">PassPort</option>
              </Field>
              <input
                type="file"
                name="idProofDoc"
                id="idProofDoc"
                // className={
                //     formik.touched.idProofDoc && formik.errors.idProofDoc
                //       ? "errorStyle form-control bg-white"
                //       : !formik.errors.Doc && formik.touched.idProofDoc
                //       ? "successField form-control bg-white"
                //       : "form-control bg-white"
                //   }
                onChange={(e) =>
                  handleFileUpload(e, formik.setFieldValue, "idProofDoc").then(formik.handleChange(e))
                }
              ></input>
              <ErrorMessage name="idProof" component={TextError} />
              <ErrorMessage name="idProofDoc" component={TextError} />
            </div>

            <div className="form-group mb-4 ">
              <label htmlFor="adProof fw-bold">Address Proof</label>
              <Field
                as="select"
                name="adProof"
                id="adProof"
                className={
                  formik.touched.adProof && formik.errors.adProof
                    ? "errorStyle form-control bg-white"
                    : !formik.errors.adProof && formik.touched.adProof
                      ? "successField form-control bg-white"
                      : "form-control bg-white"
                }
              >
                <option>Select Options</option>
                <option value="C03">Voter Id</option>
                <option value="C04">Driving Licence</option>
                <option value="C05">PassPort</option>
              </Field>
              <input
                type="file"
                name="adProofDoc"
                id="adProofDoc"
                onChange={(e) =>
                  handleFileUpload(e, formik.setFieldValue, "adProofDoc").then(formik.handleChange(e))
                }
              ></input>
              <ErrorMessage name="adProof" component={TextError} />
              <ErrorMessage name="adProofDoc" component={TextError} />
            </div>
          </div>
          <div className=" btn-sec  position-fixed bottom-0 ">
            {formik.isSubmitting ? (
              <div className="mx-auto">
                <CircularProgress
                  size={48}
                  sx={{
                    color: "red",
                  }}
                />
              </div>
            ) : (
              <>
                <button
                  className="reset-btn text-capitalize"
                //type="reset"
                //onClick={()=>resetForm()}
                >
                  Go Back
                </button>
                <button
                  className="submitBtn text-capitalize "
                  type="submit"
                  disabled={formik.isSubmitting}
                >
                  Submit
                </button>
              </>
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default DocForm;
